export enum EventType {
  AgentAvailabilityFocusEntered = 'AGENT_AVAILABILITY/FOCUS_ENTERED',
  AgentAvailabilityFocusExited = 'AGENT_AVAILABILITY/FOCUS_EXITED',
  AgentAvailabilityUpdated = 'AGENT_AVAILABILITY/UPDATED',
  AgentStatusChangedActiveReason = 'AGENT_STATUS/CHANGED_ACTIVE_REASON',
  AgentStatusLoggedIn = 'AGENT_STATUS/LOGGED_IN',
  AgentStatusLoggedOut = 'AGENT_STATUS/LOGGED_OUT',
  AgentStatusReturnedFromAway = 'AGENT_STATUS/RETURNED_FROM_AWAY',
  AgentStatusWentAway = 'AGENT_STATUS/WENT_AWAY',
  AutomationMessageReceived = 'AUTOMATION/MESSAGE_RECEIVED',
  AutomationMessageSent = 'AUTOMATION/MESSAGE_SENT',
  ContactEnded = 'CONTACT/ENDED',
  ContactFulfilled = 'CONTACT/FULFILLED',
  ContactHoldEnded = 'CONTACT/HOLD_ENDED',
  ContactHoldStarted = 'CONTACT/HOLD_STARTED',
  ContactJoined = 'CONTACT/JOINED',
  ContactMessageReceived = 'CONTACT/MESSAGE_RECEIVED',
  ContactMessageSent = 'CONTACT/MESSAGE_SENT',
  ContactOfferAccepted = 'CONTACT/OFFER_ACCEPTED',
  ContactOffered = 'CONTACT/OFFERED',
  ContactOfferRejected = 'CONTACT/OFFER_REJECTED',
  ContactTransferred = 'CONTACT/TRANSFERRED',
  ContactStarted = 'CONTACT/STARTED',
  ConversationClosedEventType = 'CONVERSATION/CLOSED',
  ConversationCreatedEventType = 'CONVERSATION/CREATED',
  ConversationCustomAttributeAddedEventType = 'CONVERSATION/CUSTOM_ATTRIBUTE_ADDED',
  ConversationCustomAttributeRemovedEventType = 'CONVERSATION/CUSTOM_ATTRIBUTE_REMOVED',
  ConversationNoteCreated = 'CONVERSATION/NOTE_CREATED',
  ConversationReopenedEventType = 'CONVERSATION/REOPENED',
  ConversationTopicAdded = 'CONVERSATION/TOPIC_ADDED',
  ConversationTopicRemoved = 'CONVERSATION/TOPIC_REMOVED',
  ConversationAssigneeUpdated = 'CONVERSATION_ASSIGNEE/UPDATED',
  ConversationStatusUpdated = 'CONVERSATION_STATUS/UPDATED',
  CustomChannelMessageSent = 'CUSTOM_CHANNEL/MESSAGE_SENT',
  CustomerMergedEventType = 'CUSTOMER/MERGED',
  CustomerProfileCreatedEventType = 'CUSTOMER_PROFILE/CREATED',
  CustomerProfileDeletedEventType = 'CUSTOMER_PROFILE/DELETED',
  CustomerProfileMergedEventType = 'CUSTOMER_PROFILE/MERGED',
  CustomerProfileUpdatedEventType = 'CUSTOMER_PROFILE/UPDATED',
  ExportJobCompletedEventType = 'EXPORT_JOB/COMPLETED',
  ExportJobFailedEventType = 'EXPORT_JOB/FAILED',
  MessageReceivedEventType = 'MESSAGE/RECEIVED',
  PaymentRequestCreated = 'PAYMENT_REQUEST/CREATED',
  PaymentRequestStatusChanged = 'PAYMENT_REQUEST/STATUS_CHANGED',
  PaymentRequestViewed = 'PAYMENT_REQUEST/VIEWED',
  TaskAssigneeUpdated = 'TASK/ASSIGNEE_UPDATED',
  TaskClosed = 'TASK/CLOSED',
  TaskCommentAdded = 'TASK/COMMENT_ADDED',
  TaskContentUpdated = 'TASK/CONTENT_UPDATED',
  TaskCreated = 'TASK/CREATED',
  TaskDueDateUpdated = 'TASK/DUE_DATE_UPDATED',
  TaskFollowerAdded = 'TASK/FOLLOWER_ADDED',
  TaskFollowerRemoved = 'TASK/FOLLOWER_REMOVED',
  TaskReopened = 'TASK/REOPENED',
}

export type Webhook = WebhookIncoming | WebhookOutgoing;
interface WebhookBase {
  id: string;
  name: string;
  enabled?: boolean;
  events?: EventType[];
  url?: string;

  disabledAtDueToRetryLimit?: string;
  createdAt?: string;
  updatedAt?: string;
}
export interface WebhookIncoming extends WebhookBase {
  hasCredentials: boolean;
  headersKeys: string[];
}

export interface WebhookOutgoing extends WebhookBase {
  headers?: WebhookHeader;
  credentials?: WebhookCredential;
}

type WebhookHeader = Record<string, string>;

type WebhookCredential = {
  username: string;
  password: string;
  realm: string;
};

type EventOption = {
  label: string;
  value: string;
};

const getWebhookEventOptions = (): EventOption[] => {
  return Object.keys(EventType).map(key => {
    return { label: EventType[key], value: EventType[key] };
  });
};

export const getFilteredWebhookEventOptions = (...eventOptions: EventType[]): readonly EventOption[] => {
  const webhookEvents = Object.keys(EventType)
    .filter(key => !eventOptions.includes(EventType[key]))
    .map(key => {
      return { label: EventType[key], value: EventType[key] };
    });
  return Object.freeze(webhookEvents);
};

export const webhookDefaultConfiguration = Object.freeze({
  enabled: false,
  events: [],
});

export const webHooksEventOptions = Object.freeze(getWebhookEventOptions());
